import React, { useReducer, useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { MainContext, mainReducer } from "./context/main";
import { safeFetchGet } from "./utils";
import { Home, Login, NotFound, Logout, Mfa, About, Phone } from "./static";
import "./styles";
import {
  WikiIndex,
  Tags,
  EditTag,
  Nabbar,
  Sms,
  New,
  Edit,
  PublicPage,
  Title,
  Page,
  Error,
  Footer,
  FileIndex,
  UploadFile,
} from "./components";

const routesWithoutNavLinks = [
  "/public",
  "/about",
  "/logout",
  "/login",
  "/mfa",
  "/support",
];

const checkLogin = () => {
  (async () => {
    const isLoggedIn = await safeFetchGet({
      url: "/api/user/doublecheck",
    });
    if (
      !isLoggedIn &&
      !window.location.pathname.includes("mfa") &&
      !window.location.pathname.includes("login")
    ) {
      window.location.href = `/login?redirect=${window.location.pathname}`;
    }
  })();
};

export default function App() {
  const [mainStore, mainDispatch] = useReducer(mainReducer, {});
  const buttons = mainStore.navButtons;
  const [showNavLinks, setShowNavLinks] = useState(true);

  useEffect(() => {
    window.addEventListener("focus", checkLogin);
    return () => {
      window.removeEventListener("focus", checkLogin);
    };
  }, []);

  useEffect(() => {
    let nextShowNavLinks = true;
    for (let route of routesWithoutNavLinks) {
      if (window.location.pathname.substring(0, route.length) === route) {
        nextShowNavLinks = false;
      }
    }
    setShowNavLinks(nextShowNavLinks);
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  return (
    <MainContext.Provider value={{ mainStore, mainDispatch }}>
      <div className="App">
        <Error />
        <Router>
          <Nabbar
            buttons={buttons}
            menuItems={
              showNavLinks
                ? [
                    {
                      href: "/new",
                      title: (
                        <>
                          <img alt="" src="/pics/acorn.png" /> New Post
                        </>
                      ),
                    },
                    {
                      href: "/sms",
                      title: (
                        <>
                          <img alt="" src="/pics/acorn.png" /> SMS Messages
                        </>
                      ),
                    },
                    //{
                      //href: "/files",
                      //title: (
                        //<>
                          //<img alt="" src="/pics/acorn.png" /> Files
                        //</>
                      //),
                    //},
                    {
                      onClick: () => {
                        if (
                          window.confirm("Are you sure you want to log out?")
                        ) {
                          window.location.replace("/logout");
                        }
                      },
                      id: "logout",
                      title: (
                        <>
                          <img alt="" src="/pics/acorn.png" /> Log out
                        </>
                      ),
                    },
                  ]
                : [
                    {
                      href: "/",
                      title: (
                        <>
                          <img alt="" src="/pics/acorn.png" /> Home
                        </>
                      ),
                    },
                    {
                      href: "/login",
                      title: (
                        <>
                          <img alt="" src="/pics/acorn.png" /> Log in / Sign Up
                        </>
                      ),
                    },
                    {
                      href: "/about",
                      title: (
                        <>
                          <img alt="" src="/pics/acorn.png" /> About
                        </>
                      ),
                    },
                  ]
            }
          />
          <div className="Body ">
            <div className="container">
              <Switch>
                <Route exact path="/login">
                  <Title title="Login" />
                  <Login />
                </Route>
                <Route exact path="/mfa">
                  <Title title="Access code" />
                  <Mfa />
                </Route>
                <Route exact path="/logout">
                  <Title title="Logout" />
                  <Logout />
                </Route>
                <Route exact path="/home">
                  <WikiIndex />
                </Route>
                <Route exact path="/wiki">
                  <WikiIndex />
                </Route>
                <Route path="/wiki">
                  <Page />
                </Route>
                <Route path="/edit/:id">
                  <Edit />
                </Route>
                <Route path="/public/:id">
                  <PublicPage />
                </Route>
                <Route exact path="/new">
                  <New />
                </Route>
                <Route exact path="/sms">
                  <Sms />
                </Route>
                <Route exact path="/about">
                  <About showNavLinks={showNavLinks} />
                </Route>
                <Route exact path="/phone">
                  <Phone />
                </Route>
                <Route exact path="/wiki/work">
                  <Phone />
                </Route>
                <Route exact path="/tags">
                  <Tags />
                </Route>
                <Route exact path="/tags/:id">
                  <EditTag />
                </Route>
                <Route exact path="/support/ticket">
                  Support tickets coming soon
                </Route>
                <Route exact path="/">
                  <Page />
                </Route>
                <Route exact path="/upload">
                  <S3 />
                </Route>
                <Route exact path="/files">
                  <FileIndex />
                </Route>
                {/*<NotFound />*/}
              </Switch>
            </div>
            <Footer />
          </div>
        </Router>
      </div>
    </MainContext.Provider>
  );
}

function S3() {
  return <UploadFile />;
}
